/* unplugin-vue-components disabled */import { render } from "./IPWhitelistSettings.vue?vue&type=template&id=c2e7b9d8&scoped=true&ts=true"
import script from "./IPWhitelistSettings.vue?vue&type=script&lang=tsx"
export * from "./IPWhitelistSettings.vue?vue&type=script&lang=tsx"

import "./IPWhitelistSettings.vue?vue&type=style&index=0&id=c2e7b9d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e7b9d8"]])

export default __exports__